var $ff0471b4ce2a7a28$exports = {};
// Full screen button
const $ff0471b4ce2a7a28$var$fullScreenButton = document.querySelector('#fullscreen');
const $ff0471b4ce2a7a28$var$wrapper = document.querySelector('#wrapper');
const $ff0471b4ce2a7a28$var$enterFull = document.querySelector('#enter_full');
const $ff0471b4ce2a7a28$var$exitFull = document.querySelector('#exit_full');
// Show button if browser supports full screen
if (canFullScreen()) {
    $ff0471b4ce2a7a28$var$fullScreenButton.style.display = 'inline-block';
    $ff0471b4ce2a7a28$var$fullScreenButton.addEventListener('click', async ()=>{
        toggleFullScreen($ff0471b4ce2a7a28$var$wrapper);
    });
}
// Show appropriate icon when entering/exiting full screen
document.addEventListener('fullscreenchange', ()=>{
    if (isFullScreen()) {
        $ff0471b4ce2a7a28$var$enterFull.classList.add('none');
        $ff0471b4ce2a7a28$var$exitFull.classList.remove('none');
    } else {
        $ff0471b4ce2a7a28$var$enterFull.classList.remove('none');
        $ff0471b4ce2a7a28$var$exitFull.classList.add('none');
    }
    // Show full screen button
    $ff0471b4ce2a7a28$var$fadeIn();
    $ff0471b4ce2a7a28$var$idleTimer();
});
// Hide full screen button and cursor if full screen when idle
let $ff0471b4ce2a7a28$var$idleCursorTimeout = setTimeout($ff0471b4ce2a7a28$var$fadeOut, 5000);
let $ff0471b4ce2a7a28$var$doNotHideButton = false;
let $ff0471b4ce2a7a28$var$doNotIdleTimer = false;
// Run fade in animation
function $ff0471b4ce2a7a28$var$fadeIn() {
    if ($ff0471b4ce2a7a28$var$fullScreenButton.classList.contains('fadeout')) {
        $ff0471b4ce2a7a28$var$fullScreenButton.classList.add('fadein');
        $ff0471b4ce2a7a28$var$fullScreenButton.classList.remove('fadeout');
    }
    document.body.classList.remove('hidecursor');
}
// Run fade out animation
function $ff0471b4ce2a7a28$var$fadeOut() {
    if ($ff0471b4ce2a7a28$var$doNotHideButton) return;
    if (!isFullScreen()) return;
    $ff0471b4ce2a7a28$var$doNotIdleTimer = true;
    document.body.classList.add('hidecursor');
    $ff0471b4ce2a7a28$var$fullScreenButton.classList.remove('fadein');
    $ff0471b4ce2a7a28$var$fullScreenButton.classList.add('fadeout');
    setTimeout(()=>{
        $ff0471b4ce2a7a28$var$doNotIdleTimer = false;
    }, 50);
}
// Reset idle timer
function $ff0471b4ce2a7a28$var$idleTimer() {
    clearTimeout($ff0471b4ce2a7a28$var$idleCursorTimeout);
    $ff0471b4ce2a7a28$var$idleCursorTimeout = setTimeout($ff0471b4ce2a7a28$var$fadeOut, 5000);
}
// Reset idle timer when mouse moved
document.addEventListener('mousemove', ()=>{
    if (!$ff0471b4ce2a7a28$var$doNotIdleTimer) {
        $ff0471b4ce2a7a28$var$fadeIn();
        $ff0471b4ce2a7a28$var$idleTimer();
    }
});
// Block fade out when hovering full screen button
$ff0471b4ce2a7a28$var$fullScreenButton.addEventListener('mouseenter', ()=>{
    $ff0471b4ce2a7a28$var$doNotHideButton = true;
});
// Unblock fade out when stop hovering full screen button
$ff0471b4ce2a7a28$var$fullScreenButton.addEventListener('mouseleave', ()=>{
    $ff0471b4ce2a7a28$var$doNotHideButton = false;
});


//# sourceMappingURL=timeline.5160df3f.js.map
